<div class="key-list">
  @for (row of rows; track row.label) {
    <div class="usage-row">
      <span class="usage-row__endpoint" [style.width]="labelWidth">{{ row.label }}</span>
      <div class="usage-row__bar-wrap">
        <div class="usage-row__bar" [style.width.%]="barPct(row)"></div>
      </div>
      <span class="usage-row__count">{{ row.displayValue ?? (row.value | number) }}</span>
    </div>
  }
</div>
